var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6669 9.00068V20.0007M20.6669 12.0007V23.0007M21.3377 27.6653L27.8377 24.4153C28.3459 24.1612 28.6669 23.6418 28.6669 23.0736V6.42773C28.6669 5.31266 27.4934 4.58742 26.496 5.08609L21.3377 7.66527C20.9154 7.87642 20.4183 7.87642 19.996 7.66527L13.3377 4.33609C12.9154 4.12495 12.4183 4.12495 11.996 4.33609L5.49605 7.58609C4.98787 7.84018 4.66687 8.35958 4.66687 8.92774V25.5736C4.66687 26.6887 5.84034 27.414 6.83769 26.9153L11.996 24.3361C12.4183 24.125 12.9154 24.125 13.3377 24.3361L19.996 27.6653C20.4183 27.8764 20.9154 27.8764 21.3377 27.6653Z",
    stroke: "#22C55E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.4e8148219359508898a4e8ad86d6dc36.svg";
export { ForwardRef as ReactComponent };